import { signalStoreFeature, type, withMethods } from '@ngrx/signals';
import { UserState } from './user.state';
import { User } from '../../models/user';

export function withUserSelectors() {
    return signalStoreFeature(
        {
            state: type<UserState>(),
        },
        withMethods(() => ({
            getWorkspaceIds(user: User): string[] {
                return user.workspaces?.map(w => w.workspace) || [];
            },
            getRoleIds(user: User): string[] {
                const roleIds = new Set<string>();
                user.workspaces?.forEach(w => {
                    w.roles?.forEach(roleId => roleIds.add(roleId));
                });
                return Array.from(roleIds);
            },
        }))
    );
}
